var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27C16.1418 27.0021 17.7679 26.6798 19.2847 26.0514C20.8016 25.4231 22.1793 24.5012 23.3387 23.3387C24.5012 22.1793 25.4231 20.8016 26.0514 19.2847C26.6798 17.7679 27.0021 16.1418 27 14.5C27.0021 12.8582 26.6797 11.2321 26.0514 9.71527C25.4231 8.19843 24.5012 6.8207 23.3387 5.66126C22.1793 4.49878 20.8016 3.57688 19.2847 2.94856C17.7679 2.32024 16.1418 1.99788 14.5 2.00001C12.8582 1.99792 11.2321 2.32029 9.71527 2.94861C8.19843 3.57693 6.8207 4.4988 5.66126 5.66126C4.4988 6.8207 3.57693 8.19843 2.94861 9.71527C2.32029 11.2321 1.99792 12.8582 2.00001 14.5C1.99788 16.1418 2.32024 17.7679 2.94856 19.2847C3.57688 20.8016 4.49878 22.1793 5.66126 23.3387C6.8207 24.5012 8.19843 25.4231 9.71527 26.0514C11.2321 26.6797 12.8582 27.0021 14.5 27Z",
    stroke: "#4B2D10",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.3906V14.8906C15.2417 14.8906 15.9667 14.6707 16.5834 14.2586C17.2001 13.8466 17.6807 13.2609 17.9645 12.5757C18.2484 11.8905 18.3226 11.1365 18.1779 10.409C18.0332 9.68161 17.6761 9.01342 17.1516 8.48898C16.6272 7.96453 15.959 7.60738 15.2316 7.46268C14.5042 7.31799 13.7502 7.39225 13.0649 7.67608C12.3797 7.95991 11.794 8.44055 11.382 9.05724C10.9699 9.67392 10.75 10.3989 10.75 11.1406",
    stroke: "#4B2D10",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 23.0156C14.9144 23.0156 15.3118 22.851 15.6049 22.558C15.8979 22.265 16.0625 21.8675 16.0625 21.4531C16.0625 21.0387 15.8979 20.6413 15.6049 20.3483C15.3118 20.0552 14.9144 19.8906 14.5 19.8906C14.0856 19.8906 13.6882 20.0552 13.3951 20.3483C13.1021 20.6413 12.9375 21.0387 12.9375 21.4531C12.9375 21.8675 13.1021 22.265 13.3951 22.558C13.6882 22.851 14.0856 23.0156 14.5 23.0156Z",
    fill: "#4B2D10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.39c82982f464cf671caba13e34253f21.svg";
export { ForwardRef as ReactComponent };